<div *routerOuter class="row">
  <div class="col col-120 col-lg-100 col-xl-80" *ngIf="item">

    <form-group-context label="ID">
      <span>{{ item.id }}</span>
    </form-group-context>

    <form-group-context label="Created At">
      <span>{{ item.createdAt | moment }}</span>
    </form-group-context>

    <form-group-context label="Updated At">
      <span>{{ item.updatedAt | moment }}</span>
    </form-group-context>

    <form-group-context label="Name">
      <span>{{ item.name }}</span>
    </form-group-context>

    <form-group-context label="Google product ID">
      <span>{{ item.googleProductId }}</span>
    </form-group-context>

    <form-group-context label="Apple product ID">
      <span>{{ item.appleProductId }}</span>
    </form-group-context>

    <form-group-context label="Inner">
      <badge-exist existText="Inner product" existColor="warning" [item]="item.innerProduct"></badge-exist>
    </form-group-context>

    <form-group-context label="Cost" *ngIf="item.innerProduct">
      <span>{{ item.coinsCost }}</span>
    </form-group-context>

<!--    <form-group-context label="SandBox">-->
<!--      <badge-exist existText="SandBox" existColor="success" [item]="item.sandBox"></badge-exist>-->
<!--    </form-group-context>-->

    <form-group-context label="Store">
      <entity-link type="store" [item]="item.parentStore" [relativePath]="true"></entity-link>
    </form-group-context>

    <form-group-context label="Type">
      {{ item.type | upperFirst }}
    </form-group-context>


    <form-group-context label="Project"
                        *ngIf="item.type === ProductType.NonConsumable && item.entity === 'project'">
      <entity-link type="project" [item]="item.project" [relativePath]="true"></entity-link>
    </form-group-context>

    <form-group-context label="Collection"
                        *ngIf="item.type === ProductType.NonConsumable && item.entity === 'storeCollection'">
      <entity-link type="collection" [item]="item.storeCollection" [relativePath]="true"></entity-link>
    </form-group-context>

    <form-group-context label="Coins"
                        *ngIf="item.type === ProductType.Consumable">
      <span>{{ item.amount }}</span>
    </form-group-context>

<!--    <form-group-context label="Trial"-->
<!--                        *ngIf="item.type === ProductType.Subscription">-->
<!--      <span>{{ item.trialPeriod }}</span>-->
<!--    </form-group-context>-->

    <form-group-context label="Subscription period"
                        *ngIf="item.type === ProductType.Subscription">
      <span>{{ item.subscriptionPeriod }}</span>
    </form-group-context>

  </div>
</div>

<!--name: [null, Validators.required],-->
<!--googleProductId: [null, Validators.required],-->
<!--appleProductId: [null, Validators.required],-->
<!--coinsCost: [],-->
<!--innerProduct: [false],-->
<!--parentStore: [null, Validators.required],-->
<!--type: [null, Validators.required],-->
